import { render, staticRenderFns } from "./EditClinicianStaffDetails.vue?vue&type=template&id=35c95647&"
import script from "./EditClinicianStaffDetails.vue?vue&type=script&lang=js&"
export * from "./EditClinicianStaffDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditClinicianStaffDetails.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports